import { PulseBaseProvider } from '../../base-classes';

const _settingsUri = '/api/em/v4/settings';
const _settingsCacheKey = 'settings';

export class EntityManagementSettingProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);

        this.storage.sync[_settingsCacheKey] = this.getUserSettingsSyncer.bind(this);
    }

    async getUserSettingsSyncer(params) {
        const { syncParams, resolve, reject, id } = params;
        let pathParams = { appinstanceid: syncParams.appInstanceId };
        let queryParams = {
            verbose: syncParams.verbose,
            pathParams
        };
        return await super.syncData(
            syncParams.key
            , id
            , queryParams
            , _settingsUri
            , resolve
            , reject
            , null
            , syncParams.pulseApi
        );
    }

    async getUserSettings(appInstanceId, verbose = false, stdParameters, refresh = false) {
        const syncParams = {
            appInstanceId,
            verbose: verbose
        };
       
        let idParams = {
            appInstanceId: stdParameters.appInstanceId
        };
        const id = JSON.stringify(idParams);
        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        if (refresh) {
            super.removeFromStorage(_settingsCacheKey, id);
        }
        const response = await super.loadFromStorage(_settingsCacheKey, id, syncParams);
        super.saveToStorage(_settingsCacheKey, id, response);
        return response;
    }

    async updateUserSettings(appInstanceId, verbose = false,  stdParameters, dataObject) {
        let pathParams = { appinstanceid: appInstanceId };
        const queryParams = {
            verbose: verbose,
            pathParams
        };
        let idParams = {
            appInstanceId: stdParameters.appInstanceId
        };
        const id = JSON.stringify(idParams);

        const data = JSON.stringify(dataObject);
        const response = await super.postData(queryParams, data, _settingsUri, true, null);
        if (response) {
            super.saveToStorage(_settingsCacheKey, id, response);
        }
        return response;
    }
}

